(() => {
  function init(root = document) {
    root.querySelectorAll('[data-elixx-help]').forEach(help => {
      if (help.dataset.initialized) return;
      help.dataset.initialized = 'true';
      const search = help.querySelector('[data-help-search]');
      const items = [...help.querySelectorAll('[data-help-item]')];
      const empty = help.querySelector('[data-help-empty]');
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('nl');
      search?.addEventListener('input', () => {
        const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
        let visible = 0;
        items.forEach(item => {
          const matches = terms.every(term => normalize(item.textContent).includes(term));
          item.hidden = !matches;
          if (matches) visible++;
        });
        empty.hidden = visible > 0;
      });
      help.querySelector('[data-help-no-order]')?.addEventListener('change', event => {
        const order = help.querySelector('[data-help-order]');
        order.disabled = event.target.checked;
      });
      help.querySelectorAll('a[href^="#faq-"]').forEach(link => {
        link.addEventListener('click', () => {
          const detail = help.querySelector(link.getAttribute('href'));
          if (detail) { detail.hidden = false; detail.open = true; }
        });
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
